import React from "react";

export default function LoadingOverlay({ active, children, className }) {
    return (
        <div className={`loadingOverlayContainer ${className || ''}`}>
            {children}
            {active && (
                <div className="loadingOverlaySpinner">
                    <div className="loadingOverlaySpinnerIcon" />
                </div>
            )}
        </div>
    );
}